export default __webpack_public_path__ + "static/menu-img-407378de524c75c407e94a025f3186e1.jpg";